import { config } from '../helpers'
import { handleHttpResponse, authHeader } from '../helpers';
import Cryptr from "cryptr";
import { getInstance } from '../auth';
// import { router } from "../helpers"

export const UserService = {
  login,
  // logout,
  logoutAuth0User,
  register,
  reverify,
  clientVerify,
  forgotPassword,
  newPassword,
  deleteUser,
  getClientLanguage,
  changeUserLanguage,
  changeAccessibility,
  getClientById,
  modifyUserInfos,
  loadFullUserInfos,
  loadAllTypesOfNotifications,
  updateBlockedNotifications,
  refreshToken
}


function login(email, password) {
  const cryptr = new Cryptr(config.salt);
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password: cryptr.encrypt(password) })
  };

  return fetch(`${config.apiUrl}/client/authenticate`, requestOptions)
    .then(handleHttpResponse)
    .then(user => {
      if (user.token) {
        localStorage.setItem("user-portal", JSON.stringify(user));
      }

      return user;
    })
}

async function refreshToken() {
  let auth0Instance = getInstance()
  if(!auth0Instance.loading) {
    let newToken = null
    try{
      newToken = await auth0Instance.getTokenSilently()
    } 
    catch {
      try {
        await auth0Instance.loginWithRedirect()
      } catch {
        UserService.logoutAuth0User()
      }
    }
    if(newToken) {
      localStorage.setItem('auth_token', newToken)
      location.reload()
    }
    // else {
    //   router.push("/", () => {})
    // }
  }
}

async function logoutAuth0User() {
  const token = localStorage.getItem("auth_token")

  try {
    await fetch(`${config.apiUrl}/api/admin-docs/logout`, {
      method: "POST",
      headers: token ? { Authorization: `Bearer ${token}` } : {},
      credentials: "include"
    })
  } catch (error) {
    console.warn("Failed to clear admin-docs session cookie:", error)
  }

  localStorage.removeItem("user-portal")
  localStorage.removeItem("auth_token")
  const auth0Instance = getInstance();

  if (auth0Instance && typeof auth0Instance.logout === 'function') {
    auth0Instance.logout({
      logoutParams: {
        returnTo: window.location.origin
      }
    });
  } else {
    console.warn('Auth0 instance not ready yet.');
  }
}


function register(user) {
  const cryptr = new Cryptr(config.salt);
  user.password = cryptr.encrypt(user.password);

  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(user)
  };

  return fetch(`${config.apiUrl}/client/register`, requestOptions)
    .then(handleHttpResponse)
}

function reverify(user) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(user)
  };

  return fetch(`${config.apiUrl}/client/reverify`, requestOptions)
    .then(handleHttpResponse)
}


function clientVerify(id) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id })
  };

  return fetch(`${config.apiUrl}/client/verify`, requestOptions)
    .then(handleHttpResponse)
}


function forgotPassword(email) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email })
  }

  return fetch(`${config.apiUrl}/client/forgotpassword`, requestOptions)
    .then(handleHttpResponse)
}


function newPassword({ password, id }) {
  const cryptr = new Cryptr(config.salt);
  password = cryptr.encrypt(password);

  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ password, id })
  };

  return fetch(`${config.apiUrl}/client/newpassword`, requestOptions)
    .then(handleHttpResponse)
}

function deleteUser(userId) {
  const query = `mutation{
    deleteUser(
      clientID: ${JSON.stringify(userId)}
    )
    {
      clientID
    }
  }`

  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/graphql', ...authHeader() },
    body: query
  }

  return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
    return handleHttpResponse(response)
  })
}

function getClientLanguage(id) {
  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/graphql', ...authHeader() }
  };
  const query = `clientById(id: ${JSON.stringify(id)}){
    id
    lang
  }`;
  return fetch(`${config.apiUrl}/graphql?query={${query}}`, requestOptions).then(response => {
      return handleHttpResponse(response)
      .then(data => data.clientById);
    })
}

function changeUserLanguage(id, lang) {
  localStorage.setItem("user-portal", JSON.stringify({ lang }));
  if (!id) {
    return
  }
  // lang = lang.charAt(0).toUpperCase() + lang.slice(1);
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeader() },
    body: JSON.stringify({id, lang})
  };
  return fetch(`${config.apiUrl}/label/language`, requestOptions).then(response => {
    return handleHttpResponse(response);
  })
}
function changeAccessibility(id, accessibilityEnabled) {
  localStorage.setItem('accessibilityEnabled', accessibilityEnabled);
  if (!id) {
    return
  }

  const query = `mutation{
    modifyClientAccessibility(
      id:${JSON.stringify(id)},
      accessibilityEnabled:${JSON.stringify(accessibilityEnabled)}
      ){
        id
      }
  }`;

  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/graphql', ...authHeader() },
    body: query
  }

  return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
      return handleHttpResponse(response)
      .then(data => data.modifyClientAccessibility);
  })
}

function getClientById(userID) {
  const query = `{
    clientById(
      id: ${JSON.stringify(userID)}
    )
    {
      id
      firstName
      lastName
      dgo
      email
      accessibilityEnabled
      preferredChannel
      phoneNumber
      blockedNotifications
    }
  }`

  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/graphql', ...authHeader() },
    body: query
  }

  return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
    return handleHttpResponse(response)
      .then(data => data.clientById);
  })
}

function modifyUserInfos({
  id,
  firstName,
  lastName,
  preferredChannel,
  phoneNumber,
}) {
  const query = `mutation{
    modifyUserInfos(
      userID:${JSON.stringify(id)},
      firstName:${JSON.stringify(firstName)},
      lastName:${JSON.stringify(lastName)},
      preferredChannel:${JSON.stringify(preferredChannel)},
      phoneNumber:${JSON.stringify(phoneNumber)},
      ){
        id
      }
  }`;
const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/graphql', ...authHeader() },
    body: query
  }
  return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
        return handleHttpResponse(response)
        .then(data => data.modifyUserInfos);
    })
}

function loadFullUserInfos(clientID) {
  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/graphql', ...authHeader() }
  };
  const query = `clientById(id: ${JSON.stringify(clientID)}){
    email
    createdDate
    accessibilityEnabled
    clipod {
      validFrom
      podCustomName
      pod {
        EAN
        includeIntervalReadings
        variable {
          name
          meter
          direction
          validFrom
          timeframe
          validTo
        }
        location {
          streetName
          streetNumber
          postalCode
          localityName
          country
          boxNumber
          customName
          events {
            category
            type
            description
            date
          }
        }
      }
    }
    podRequests {
      dgo
      firstName
      lastName
      phone
      mail
      EAN
      meter
      streetName
      streetNumber
      boxNumber
      localityName
      postalCode
      comment
      requestDate
      status
    }
  }`
  return fetch(`${config.apiUrl}/graphql?query={${query}}`, requestOptions).then(response => {
      return handleHttpResponse(response)
      .then(data => data.clientById);
  })
}

function loadAllTypesOfNotifications() {
  const query = `{
    allTypesOfNotifications
    {
      MANDATORY {
        NAME
        id
      }
      OPTIONAL {
        NAME
        id
      }
    }
  }`

  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/graphql', ...authHeader() },
    body: query
  }

  return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
    return handleHttpResponse(response)
      .then(data => data.allTypesOfNotifications)
  }) 
}

function updateBlockedNotifications({ clientID, idListBlockedNotifs }) {
  const query = `mutation{
    modifyBlockedNotifications(
        clientID: ${JSON.stringify(clientID)},
        idListBlockedNotifs: ${JSON.stringify(idListBlockedNotifs)}
    ) {
        id
    }
  }`
  const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/graphql', ...authHeader() },
      body: query
  }
  return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
      return handleHttpResponse(response)
      .then(data => data.modifyBlockedNotifications);
  })
}